import { environment } from '../../../../../assets/environment/environment';

export class UserManagementCollections {
  static ModuleName = 'user-management';

  static Identity = `${UserManagementCollections.ModuleName}/identity`;

  static Users = `${UserManagementCollections.ModuleName}/users`;
  static CurrentUser = `${UserManagementCollections.ModuleName}/users/me`;
  static User(userId: string) {
    return `${UserManagementCollections.Users}/${userId}`;
  }

  static Permissions = `${UserManagementCollections.ModuleName}/permissions`;

  static Scopes = `${UserManagementCollections.ModuleName}/scopes`;
  static Scope(scopeId: string) {
    return `${UserManagementCollections.Scopes}/${scopeId}`;
  }

  static ScopePermissions(scopeId: string) {
    return `${UserManagementCollections.Scope(scopeId)}/permissions`;
  }

  static ScopePrmission(scopeId: string, permissionId: string) {
    return `${UserManagementCollections.ScopePermissions(scopeId)}/${permissionId}`;
  }

  static SystemRoles = `${UserManagementCollections.ModuleName}/system-roles`;
  static SystemRole(systemRoleId: string) {
    return `${UserManagementCollections.SystemRoles}/${systemRoleId}`;
  }

  static Accounts = `${UserManagementCollections.ModuleName}/accounts`;
  static Account(accountId: string) {
    return `${UserManagementCollections.Accounts}/${accountId}`;
  }

  static AccountValidation() {
    return `${UserManagementCollections.Accounts}/validations`;
  }

  static AdminAccountValidation() {
    return `${UserManagementCollections.Accounts}/admin-validation`;
  }

  static AccountScopes(accountId: string) {
    return `${UserManagementCollections.Account(accountId)}/scopes`;
  }

  static AccountSpecializedRoles(accountId: string) {
    return `${UserManagementCollections.Account(accountId)}/specialized-roles`;
  }

  static AccountSpecializedRole(accountId: string, specializedRoleId: string) {
    return `${UserManagementCollections.AccountSpecializedRoles(accountId)}/${specializedRoleId}`;
  }

  static AccountsSpecializedRolesPermissions(accountId: string, specializedRoleId: string) {
    return `${UserManagementCollections.AccountSpecializedRole(accountId, specializedRoleId)}/permissions`;
  }

  static AccountUsers(accountId: string) {
    return `${UserManagementCollections.Account(accountId)}/users`;
  }

  static AccountUser(accountId: string, userId: string) {
    return `${UserManagementCollections.AccountUsers(accountId)}/${userId}`;
  }

  static AccountUserSpecializedRoles(accountId: string, userId: string) {
    return `${UserManagementCollections.AccountUser(accountId, userId)}/specialized-roles`;
  }

  static AccountTypes = `${UserManagementCollections.ModuleName}/account-types`;
  static AccountType(typeName: string) {
    return `${UserManagementCollections.AccountTypes}/${typeName}`;
  }
}
